<template>
  <main class="content content--narrow">

    <div class="content__heading content__heading--center">
      <figure class="fusebox--emblem">
        <img src="@/assets/svg/fusebox_online_emblem.svg"/>
      </figure>
    </div>

    <ValidationObserver ref="form" #default="{ invalid }">
      <section class="panel__container">
        <Panel v-if="!submitted && !success" :title="$t('general.register')" size="full">
          <template v-slot:body>
            <form class="form__wrapper" @keyup.enter="register()">
              <div class="field__row">
                <Field :label="$t('general.company')"
                       name="company"
                       rules="required|max:255"
                       type="text"
                       v-model="form.company"/>
              </div>
              <div class="field__row">
                <Field :label="$t('general.name')"
                       name="name"
                       rules="required|max:255"
                       type="text"
                       v-model="form.name"/>
              </div>
              <div class="field__row">
                <Field :label="$t('general.email')"
                       name="email"
                       rules="required|email|unique|max:255"
                       type="email"
                       v-model="form.email"/>
              </div>
              <div class="field__row">
                <FieldSelect :label="$t('general.country')"
                             name="country"
                             :items="countryList"
                             rules="required"
                             label-key="name"
                             value-key="code"
                             :placeholder="$t('general.country_select')"
                             v-model="form.country_code"/>
              </div>
              <div class="field__row">
                <Field :label="$t('general.password')"
                       name="password"
                       rules="required|min:3"
                       type="password"
                       v-model="form.password"/>
              </div>
              <div class="field__row">
                <Field :label="$t('general.password_confirmation')"
                       name="password_confirmation"
                       rules="required|confirmed:password"
                       type="password"
                       v-model="form.password_confirmation"/>
              </div>

              <i18n path="terms.finalize" tag="small">
                <a @click=showModalTos class="link link--bold lowercase">{{ $t('terms.tos') }}</a>
                <a @click=showModalPrivacy class="link link--bold lowercase">{{ $t('terms.privacy') }}</a>
              </i18n>

            </form>
          </template>
          <template v-slot:footer>

            <div class="btn--bar">
              <button class="btn" :disabled="invalid || submitted" @click="register()" type="button">
                <i class="icon--check"></i> {{ $t('general.register') }}
              </button>

              <router-link :to="{ name: 'auth.login' }" class="btn btn--secondary">{{ $t('general.haveAccount') }}
              </router-link>

            </div>

          </template>
        </Panel>
        <Panel v-else-if="success" :title="$t('general.registerComplete')" size="full">
          <template v-slot:body>
            {{ $t('general.registerSuccess') }}

            <div class="btn--bar">
              <router-link :to="{ name: 'auth.login' }" class="btn btn--center">{{ $t('general.loginToFusebox') }}
              </router-link>

            </div>
          </template>
        </Panel>
      </section>
    </ValidationObserver>
    <ModalTos @hideModal="hideModalTos"/>
    <ModalPrivacy @hideModal="hideModalPrivacy"/>
  </main>
</template>

<script>
import Panel from '@/components/Parts/Panel.vue'
import Field from '@/components/Parts/Field.vue'
import { ROLES } from '@/constants'
import { errHandler } from '@/helpers'
import FieldSelect from '@/components/Parts/FieldSelect'
import ModalTos from '@/components/Modal/Tos'
import ModalPrivacy from '@/components/Modal/Privacy'

export default {
  name: 'Register',
  mounted () {
    this.init()
  },
  components: {
    Panel,
    Field,
    FieldSelect,
    ModalPrivacy,
    ModalTos
  },
  data () {
    return {
      submitted: false,
      success: false,
      countryList: [],
      form: {
        company: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: ROLES.COMPANY.ROLE_ADMIN,
        country_code: ''
      }
    }
  },
  methods: {
    showModalPrivacy () {
      this.$modal.show('privacy')
    },
    hideModalPrivacy () {
      this.$modal.hide('privacy')
    },
    showModalTos () {
      this.$modal.show('tos')
    },
    hideModalTos () {
      this.$modal.hide('tos')
    },

    async register () {
      if (await this.$refs.form.validate()) {
        try {
          this.submitted = true
          await this.$store.dispatch('auth/register', this.form)
          this.success = true
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submitted = false
        }
      }
    },
    async init () {
      this.countryList = await this.$store.dispatch('countryList')
    }
  }
}
</script>
